import React, { useContext, useEffect, useMemo, useState } from 'react'

import { Button, Popover, Input, Dropdown, Menu, Tooltip, Select } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { debounce, isFunction, isString, isUndefined } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import ShiftsExportOptions from '../ShiftsExportOptions'
import { Contexts, InstitutionOptions } from '../../../../utils/constants'
import { faBars, faCog, faFileExport, faFilter, faFont, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import StandardSelect, { STRING } from '../../../antd/Selects/StandardSelect'
import { isObject } from '../../../../utils'
import { getTranslate } from 'react-localize-redux'
import { getUser } from '../../../../reducers/UserReducer'
import { getSelectedInstitution, getSelectedSector, setSelectedInstitution, setSelectedSector } from '../../../../reducers/ShiftsManagerReducer/actions'
import { getInstitutionSectors } from '../../../../utils/api/institution'
import InternshipFilters, { getActiveFiltersCount } from '../../../../Views/institution/InternshipsView/InternshipsList/InternshipFilters'
import { GlobalFiltersContext } from '../../../../Providers/GlobalFiltersProvider'
import { ColorsPalette } from '../../../../config/colors'
import { GlobalContext } from '../../../../Providers/GlobalProvider'
import DraftButton from '../../DraftButton'
import useModules from '../../../../hooks/useModules'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import InstitutionsSelector from '../../Selectors/Institution/InstitutionsSelector'
import { isInstitutionGroupAdmin } from '../../../../utils/roles'
import { SchoolContext } from '../../../../Providers/SchoolProvider'

export const CONTEXT_SHIFTS_INSTITUTION_KEY = 'shifts_manager_institution'

const Search = Input.Search
const SEARCH_WIDTH = 175

const SECTOR_KEY = 'name'

const mapStateToProps = state => {
  return {
    t: getTranslate(state.locale),
    user: getUser(state.getUser),
    selectedInstitution: getSelectedInstitution(state),
    selectedSector: getSelectedSector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSelectedInstitution: bindActionCreators(setSelectedInstitution, dispatch),
    setSelectedSector: bindActionCreators(setSelectedSector, dispatch)
  }
}

const ActionsFieldsAndButtons = ({
  checkedInternships, disabled, exportLoading, institutionOptions, limitedActions, loading, multiSelectionMode,
  showTopTransitions, selectedInstitution, selectedSector, useDraft, user, displayManagePresets, onDeleteSchedules, onDraftChange,
  onDraftSchedules, onExport, onPublishSchedules, onResetFilters, onResetSelection, setSelectedInstitution, setSelectedSector,
  toggleMultiSelect, t, setFontSizes, onCancelSchedule
}) => {
  const { internshipFilters, internshipSearch, setInternshipSearch } = useContext(GlobalFiltersContext)
  const { isReadOnly } = useContext(GlobalContext)
  const ic = useContext(InstitutionContext)
  const sc = useContext(SchoolContext)

  const modules = useModules()

  const [sectors, setSectors] = useState([])
  const [localInternshipSearch, setLocalInternshipSearch] = useState(internshipSearch)
  const [hovered, setHovered] = useState(false)

  const usePausesModule = isObject(ic) && ic.options[InstitutionOptions.QUOTA_PER_PAUSE]
  const isHospitalUser = useMemo(() => user.context === Contexts.INSTITUTION, [user.context])

  useEffect(() => {
    if (selectedInstitution && user) {
      const institution = isString(selectedInstitution) ? { id: selectedInstitution } : selectedInstitution
      getInstitutionSectors(user, institution).then(({ data }) => setSectors(data))
    }
  }, [selectedInstitution, user])

  useEffect(() => {
    const modifySearch = debounce(() => setInternshipSearch(localInternshipSearch.trim()), 400)

    modifySearch()

    return () => {
      modifySearch.cancel()
    }
  }, [localInternshipSearch])

  const handleToggleMultiSelect = () => {
    toggleMultiSelect()
  }

  const handleManagePresetDisplaying = () => {
    if (isFunction(displayManagePresets)) {
      displayManagePresets()
    }
  }

  const handleInstitutionSelected = institution => {
    if (isObject(selectedSector) && selectedSector.id) {
      setSelectedSector({})
    }

    if (sectors.length > 0) {
      setSectors([])
    }

    if (isUndefined(institution)) {
      institution = null
    }

    setSelectedInstitution(institution)
  }

  const renderLegendWrapper = () => {
    let body = []

    if (!limitedActions) {
      body.push(
        <Button
          key='multi-selection-activator'
          ghost={!!multiSelectionMode}
          type={multiSelectionMode ? 'danger' : 'default'}
          onClick={handleToggleMultiSelect}
        >
          <FontAwesomeIcon icon={faBars} /> &nbsp; {t(multiSelectionMode ? 'Exit selection mode' : 'Select shifts')}
        </Button>
      )
    }

    if (isHospitalUser && !isReadOnly && !isInstitutionGroupAdmin(user)) {
      body.push(
        <Button
          key='presets-manager'
          type='default'
          onClick={handleManagePresetDisplaying}
          style={{ marginLeft: '10px' }}
        >
          <FontAwesomeIcon icon={faClock} />
            &nbsp;
          {t('views.shifts_manager.alt_title')}
        </Button>
      )
    }

    if (usePausesModule || !isHospitalUser || isInstitutionGroupAdmin(user)) {
      body = body.concat(renderPausesModuleOptions())
    }

    return (
      <div className='legend-wrapper'>
        {body}
      </div>
    )
  }

  const renderPausesModuleOptions = () => {
    const body = []

    if (isHospitalUser === false || isInstitutionGroupAdmin(user)) {
      body.push(
        <div>
          <InstitutionsSelector
            key='pauses-institutions-selector'
            disabled={disabled}
            empty
            institutions={isObject(sc) && sc.useLinkedInstitutions ? sc.institutions : null}
            values={isString(selectedInstitution) ? selectedInstitution : null}
            reverse
            style={{ width: '250px', marginLeft: '10px' }}
            onChange={handleInstitutionSelected}
          />
        </div>
      )
    }

    if (sectors.length > 0) {
      body.push(
        <StandardSelect
          key='pauses-sectors-selector'
          showSearch
          emptyOption
          data={sectors}
          dataKey={SECTOR_KEY}
          dataType={STRING}
          nullData={{}}
          disabled={disabled}
          value={selectedSector && selectedSector[SECTOR_KEY] ? selectedSector[SECTOR_KEY] : '/'}
          onSelect={setSelectedSector}
          style={{ width: '175px', marginLeft: '10px' }}
        />
      )
    }

    return body
  }

  const renderExportAndDatesButtons = () => {
    return (
      <div className={`export-buttons ${showTopTransitions ? 'with-transition' : ''}`}>
        <div className='h-spacing' />
        <Popover
          placement='left'
          title={(
            <div className='shifts-export-title'>
              <FontAwesomeIcon icon={faFileExport} />
              &nbsp;
              {t('Export')}
            </div>
          )}
          content={
            <ShiftsExportOptions onExportOptionSelected={onExport} />
          }
        >
          <Button
            type='default'
            loading={exportLoading}
          >
            <FontAwesomeIcon icon={faFileExport} />
            &nbsp;
            {t('Export')}
          </Button>
        </Popover>
      </div>
    )
  }

  return (
    <div className='flex-row'>
      <Search
        placeholder={t('Filter internships')}
        value={localInternshipSearch}
        style={{ width: SEARCH_WIDTH }}
        className='app-tour-2'
        onChange={e => setLocalInternshipSearch(e.target.value)}
      />
      <div className='h-spacing' />
      <Dropdown
        overlay={
          <Menu>
            <Menu.ItemGroup title={t('common.filters')}>
              <Menu.Item disabled style={{ cursor: 'default' }}>
                <InternshipFilters
                  internshipFilters={internshipFilters}
                  loading={loading}
                  user={user}
                  onFilterChange={() => {}}
                  context={CONTEXT_SHIFTS_INSTITUTION_KEY}
                />
              </Menu.Item>
            </Menu.ItemGroup>
          </Menu>
        }
        overlayClassName='custom-overlay'
        trigger={['click']}
      >
        <div
          className='filter-button-wrapper'
          style={{ position: 'relative', display: 'inline-block' }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {getActiveFiltersCount(internshipFilters) > 0 && hovered && (
            <span
              aria-hidden
              style={{
                position: 'absolute',
                right: '7px',
                top: '5px',
                zIndex: '100',
                cursor: 'pointer'
              }}
            >
              <FontAwesomeIcon
                size='xl' onClick={(e) => {
                  onResetFilters()
                  e.stopPropagation()
                }} icon={faCircleXmark}
              />
            </span>
          )}

          <Button style={getActiveFiltersCount(internshipFilters) > 0 ? { color: '#52c41a', borderColor: '#52c41a' } : {}} className='flex-button'>
            <FontAwesomeIcon icon={faFilter} />
            {getActiveFiltersCount(internshipFilters) > 0 && <span style={{ marginLeft: '5px' }}> {getActiveFiltersCount(internshipFilters)} {getActiveFiltersCount(internshipFilters) === 1 ? t('filters.count.filter') : t('filters.count.filters')}</span>}
          </Button>
        </div>
      </Dropdown>
      <div className='h-spacing' />
      {renderLegendWrapper()}
      {!isReadOnly && modules.internshipsDraft && <DraftButton />}

      <div className='h-spacing' />
      <Dropdown
        overlayStyle={{ width: '200px' }}
        trigger={['click']}
        overlay={
          <Menu>
            <Menu.Item key='1' disabled style={{ padding: 0 }}>
              <div style={{ width: '100%', height: '100%', cursor: 'default', padding: '10px', color: 'black' }}>
                <FontAwesomeIcon color={ColorsPalette.SECOND} icon={faFont} />
                {t('common.font_size')}
                <div style={{ height: '5px' }} />
                <Select
                  defaultValue='default'
                  style={{ width: 120 }}
                  onChange={value => {
                    if (value === 'default') {
                      setFontSizes({
                        content: '16px',
                        time: '8px'
                      })
                    } else if (value === 'large') {
                      setFontSizes({
                        content: '18px',
                        time: '12px'
                      })
                    } else if (value === 'xlarge') {
                      setFontSizes({
                        content: '22px',
                        time: '16px'
                      })
                    }
                  }}
                >
                  <Select.Option value='default'>{t('common.default')}</Select.Option>
                  <Select.Option value='large'>{t('common.large')}</Select.Option>
                  <Select.Option value='xlarge'>{t('common.larger')}</Select.Option>
                </Select>
              </div>
            </Menu.Item>
          </Menu>
        }
      >
        <Tooltip
          placement='top'
          title={t('Settings')}
        >
          <Button type='default'><FontAwesomeIcon icon={faCog} /></Button>
        </Tooltip>
      </Dropdown>

      <div className='flex-fill' />
      {renderExportAndDatesButtons()}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsFieldsAndButtons)
